
export const onAdobeConsentChange = (consent = []) => {
    try {
        if (!window.adobe) {
            return;
        }
        const optInCategories = adobe?.OptInCategories || {};
        const adobeResult = []
        for(const optInType in optInCategories) {
            if(consent.indexOf(optInCategories[optInType]) !== -1) {
                adobeResult.push(optInCategories[optInType])
            }
        }
        if (adobeResult.length) {
            adobe?.optIn?.approve?.(adobeResult, true);
            adobe?.optIn?.complete?.();
        }
    } catch (error) {
        console.log("onAdobeConsentChange error", error)
    }
};